import { Box, HStack, IconButton, Stack, Text } from "@chakra-ui/react";
import { Card } from "@components/ui-kit";
import autoAnimate from "@formkit/auto-animate";
import { Trans, t } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { useStore } from "@src/utils/hooks";
import { NumberModel } from "@src/utils/models";
import { observer } from "mobx-react-lite";
import { useCallback, useEffect, useRef } from "react";
import { useInvoiceStore } from "../../../../store";
import { AddPrepaymentButton } from "./AddPrepaymentButton";
import { PrepaymentItem } from "./PrepaymentItem";

export const PrepaymentsCard = observer(function PrepaymentsCard() {
  const { workspaceStore } = useStore();
  const store = useInvoiceStore();
  const parent = useRef<HTMLDivElement>(null);

  const createEmptyPrepaymentSplit = useCallback(() => {
    store.form.addPrepaymentSplit(
      "",
      "",
      new NumberModel(0, workspaceStore.settings!.currency.denomination),
    );
  }, []);

  const removePrepaymentSplit = useCallback((idx: any) => {
    store.form.removePrepaymentSplit(idx);
  }, []);

  useEffect(() => {
    parent.current && autoAnimate(parent.current);
  }, [parent, store.form.prepayment_splits.$.length]);

  const button = <AddPrepaymentButton onClick={createEmptyPrepaymentSplit} />;

  const card = (
    <Card sectioned>
      <HStack mb="6">
        <h2 className="text-3xl font-semibold mr-2">
          <Trans>Prepayment</Trans>
        </h2>

        <IconButton
          aria-label={t`Add prepayment item`}
          icon={<Icon name="plus-circle" w="6" h="6" color="blue.500" />}
          onClick={createEmptyPrepaymentSplit}
          variant="plain"
        />
      </HStack>

      <Stack ref={parent} spacing="3">
        {store.form.prepayment_splits.$.map((i, idx) => (
          <PrepaymentItem
            // TODO: Add unique IDs to prepayment_splits
            // biome-ignore lint/suspicious/noArrayIndexKey: we need to use the index as key because the item is not unique
            key={idx}
            item={i}
            onRemove={() => removePrepaymentSplit(idx)}
          />
        ))}
        {store.selectedMultipleTeams && (
          <Text>
            <Trans>
              Prepayments are disabled because there are multiple teams
              selected.
            </Trans>
          </Text>
        )}
      </Stack>
    </Card>
  );

  return (
    <Box ref={parent}>
      {!store.form.prepayment_splits.$.length ? button : card}
    </Box>
  );
});
